import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  paper: {
    width: theme.spacing(50.5),
    maxWidth: `calc(100% - ${theme.spacing(4)})`,
    borderRadius: 8,
    border: `1px solid ${theme.palette.stages.hovered}`,
    boxShadow: theme.shadows[3],
  },
  list: {
    maxHeight: theme.spacing(19.25),
    padding: `${theme.spacing(0.5)} 0`,
    overflowY: 'auto',
  },
  item: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(3.75),
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    fontFamily: 'Inter, sans-serif',
    fontSize: 12,
    lineHeight: '14px',
    color: theme.palette.labraText.tertiary,
    '&:hover': {
      backgroundColor: theme.palette.labraChat.hoverBg,
    },
    // tss-react has no $ruleName selectors, so the row reveals its delete
    // button through a literal class name.
    '&:hover .savedPromptDelete': {
      visibility: 'visible',
    },
    // LabraToolTipV2 wraps its child in a plain <div>, and that div — not the
    // text inside it — is the flex child. Without this it sizes to the full
    // prompt and nothing ever truncates.
    '& > div': {
      flex: '1 1 100%',
      minWidth: 0,
      overflow: 'hidden',
    },
  },
  itemText: {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    color: 'inherit',
  },
  // Sits over the text rather than beside it (see Figma 345:2490), so a prompt
  // runs the full width of the row and only gives way where the icon lands.
  // Hidden rather than removed, so revealing it never reflows the row.
  deleteButton: {
    position: 'absolute',
    right: theme.spacing(2),
    zIndex: 1,
    border: 'none',
    padding: `0 0 0 ${theme.spacing(1)}`,
    cursor: 'pointer',
    display: 'inline-flex',
    visibility: 'hidden',
    fontSize: 13,
    lineHeight: 1,
    color: theme.palette.labraText.description,
    // Masks the ellipsis running underneath it.
    backgroundColor: theme.palette.labraChat.hoverBg,
    '&:hover': {
      color: theme.palette.labraText.tertiary,
    },
  },
  message: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    fontFamily: 'Inter, sans-serif',
    fontSize: 12,
    lineHeight: '14px',
    color: theme.palette.labraText.description,
  },
}))
